<template>
  <div id="app" style="width: 100%">
    <div class="page-header">
      <div class="page-title">角色列表</div>
      <div class="page-header-btn">
        <el-button icon="el-icon-plus" size="mini" style="margin-right: 1rem" type="primary" @click="addRole">
          添加角色
        </el-button>
      </div>
    </div>
    <!--用户列表-->
    <el-table size="medium" :data="RoleList" style="width: 100%; font-size: 12px" :height="$tableHeght"
      header-row-class-name="table-header">
      <el-table-column prop="name" label="角色名称" min-width="160" />
      <el-table-column prop="authority" label="权限" min-width="160" />
      <!-- <el-table-column prop="desc" label="类型" min-width="160"/> -->
      <el-table-column label="操作" min-width="450" fixed="right">
        <template v-slot:default="scope">
          <!-- <el-button size="medium" icon="el-icon-edit" type="text" @click="edit(scope.row)">修改密码</el-button> -->
          <!-- <el-divider direction="vertical"></el-divider> -->
          <!-- <el-button size="medium" icon="el-icon-edit" type="text" @click="changePushKey(scope.row)">修改pushkey</el-button> -->
          <!-- <el-divider direction="vertical"></el-divider> -->
          <!-- <el-button size="medium" icon="el-icon-edit" type="text" @click="showUserApiKeyManager(scope.row)">管理ApiKey</el-button> -->
          <!-- <el-divider direction="vertical"></el-divider> -->
          <el-button size="medium" icon="el-icon-edit" type="text" @click="edit(scope.row)">编辑</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button size="medium" icon="el-icon-delete" type="text" @click="deleteRole(scope.row)" style="color: #f56c6c">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <changePasswordForAdmin ref="changePasswordForAdmin"></changePasswordForAdmin>
    <changePushKey ref="changePushKey"></changePushKey>
    <addRole ref="addRole"></addRole>
    <editRole ref="editRole"></editRole>
    <el-pagination style="text-align: right" @size-change="handleSizeChange" @current-change="currentChange"
      :current-page="currentPage" :page-size="count" :page-sizes="[15, 25, 35, 50]"
      layout="total, sizes, prev, pager, next" :total="total">
    </el-pagination>
  </div>
</template>

<script>
import uiHeader from "../layout/UiHeader.vue";
import changePasswordForAdmin from "./dialog/changePasswordForAdmin.vue";
import changePushKey from "./dialog/changePushKey.vue";
import addRole from "../components/dialog/addRole.vue";
import editRole from "../components/dialog/editRole.vue";

export default {
  name: "roleManager",
  components: {
    uiHeader,
    changePasswordForAdmin,
    changePushKey,
    addRole,
    editRole,
  },
  data() {
    return {
      RoleList: [],
      currentUser: {},
      videoComponentList: [],
      updateLooper: 0,
      currentUserLenth: 0,
      currentPage: 1,
      count: 15,
      total: 0,
      getRoleListLoading: false,
    };
  },
  mounted() {
    this.initData();
    this.updateLooper = setInterval(this.initData, 10000);
  },
  destroyed() {
    this.$destroy("videojs");
    clearTimeout(this.updateLooper);
  },
  methods: {
    initData: function () {
      this.getRoleList();
    },
    currentChange: function (val) {
      this.currentPage = val;
      this.getRoleList();
    },
    handleSizeChange: function (val) {
      this.count = val;
      this.getRoleList();
    },
    getRoleList: function () {
      let that = this;
      this.getRoleListLoading = true;
      this.$axios({
        method: "get",
        url: `/api/role/all`,
        params: {
          page: that.currentPage,
          count: that.count,
        },
      })
        .then(function (res) {
          if (res.data.code === 0) {
            // that.total = res.data.data.total;
            that.RoleList = res.data.data;
          }
          that.getRoleListLoading = false;
        })
        .catch(function (error) {
          that.getRoleListLoading = false;
        });
    },
    edit: function (row) {
      this.$refs.editRole.openDialog(row, () => {
        this.$refs.editRole.close();
        this.$message({
          showClose: true,
          message: "角色更新成功",
          type: "success",
        });
        setTimeout(this.getRoleList, 200);
      });
    },
    deleteRole: function (row) {
      let msg = "删除后不可恢复，确定删除此角色？";
      this.$confirm(msg, "提示", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
        type: "warning",
      })
        .then(() => {
          this.$axios({
            method: "delete",
            url: `/api/role/delete?id=${row.id}`,
          })
            .then((res) => {
              this.getRoleList();
            })
            .catch((error) => {
              console.error(error);
            });
        })
        .catch(() => { });
    },

    changePushKey: function (row) {
      this.$refs.changePushKey.openDialog(row, () => {
        this.$refs.changePushKey.close();
        this.$message({
          showClose: true,
          message: "pushKey修改成功",
          type: "success",
        });
        setTimeout(this.getRoleList, 200);
      });
    },
    addRole: function () {
      // this.$refs.addRole.openDialog()
      this.$refs.addRole.openDialog(() => {
        this.$refs.addRole.close();
        this.$message({
          showClose: true,
          message: "用户添加成功",
          type: "success",
        });
        setTimeout(this.getRoleList, 200);
      });
    },
    showUserApiKeyManager: function (row) {
      this.$router.push(`/userApiKeyManager/${row.id}`);
    },
  },
};
</script>
<style>
.videoList {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.video-item {
  position: relative;
  width: 15rem;
  height: 10rem;
  margin-right: 1rem;
  background-color: #000000;
}

.video-item-img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 100%;
}

.video-item-img:after {
  content: "";
  display: inline-block;
  position: absolute;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 3rem;
  height: 3rem;
  background-image: url("../assets/loading.png");
  background-size: cover;
  background-color: #000000;
}

.video-item-title {
  position: absolute;
  bottom: 0;
  color: #000000;
  background-color: #ffffff;
  line-height: 1.5rem;
  padding: 0.3rem;
  width: 14.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RoleManager.vue